<template>
  <div>
    <!-- Loader -->
    <PageLoader
      v-if="showOptions.loader"
      :showLoader="true"
      :content="loaderContent"
      class="page-loader-main"
    ></PageLoader>

    <!-- Zero State -->
    <div v-if="showOptions.zeroState" class="state-wrapper no-access">
      <img
        src="@/assets/images/doodles/no-access.jpg"
        class="asset"
        alt="No access"
      />
      <h3>You don't have access</h3>
      <p>Please reach out to your Zendesk admin or Macha support for help.</p>
    </div>
  </div>
</template>

<script>
// Components
import PageLoader from "@/components/loaders/PageLoader";

// Services
import { AuthService } from "@/services";

export default {
  name: "WidgetSettings",
  data() {
    return {
      showOptions: {
        loader: true,
        zeroState: false,
      },
      loaderContent: {
        title: "Authenticating...",
        description: "Confirming your admin access",
      },
    };
  },
  components: {
    PageLoader,
  },
  computed: {},
  async created() {
    this.authenticateToken();
  },
  methods: {
    async authenticateToken() {
      const ssoToken = this.$route.query.ssoToken;
      const app = this.$route.query.app;

      if (ssoToken) {
        const data = { ssoToken };
        const response = await AuthService.AuthenticateToken(data);

        if (!response.hasError) {
          this.$store.commit("updateIsSso", true);
          await this.getUser();
          this.$router.push({ path: `/apps/${app}` });
        }
      }

      this.showOptions.loader = false;
      this.showOptions.zeroState = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.page-loader-main {
  margin-top: 5%;
}

.state-wrapper {
  margin: 5% 10% 0;
  text-align: center;
  flex: 1;
  height: 100%;
}

.state-wrapper .asset {
  width: 8rem;
  display: block;
  margin: 0 auto 1.5rem;
}

.state-wrapper h3 {
  font-size: $mediumFontSize;
}

.state-wrapper p {
  font-size: $smallFontSize;
  margin-top: 0.25rem;
  display: block;
}
</style>
